export default "__VITE_ASSET__BHC12C0L__"